<template>
  <section id="travelers">
    <TravelerList v-show="!isForm" v-model:edit-id="editId" v-model:is-form="isForm" v-model:is-no-pax="isNoPax" v-model:new-id="newId" v-model:travelers="travelers" :is-wizard="true" />
    <TravelerForm v-show="isForm" v-bind="$attrs" v-model:edit-id="editId" v-model:is-form="isForm" v-model:is-no-pax="isNoPax" v-model:new-id="newId" :is-wizard="true" @next="next" @back="back" @error="$emit('error', $event)" />
    <div v-if="!isForm" id="navigation">
      <button @click="next">Next Step</button>
      <a @click="back">Back</a>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import TravelerForm from "../components/common/TravelerForm.vue";
import TravelerList from "../components/common/TravelerList.vue";

const props = defineProps({
  sectionsTravelersIds: Array,
  isSelfBook: Boolean,
});

const emit = defineEmits(["back", "error", "update:sectionsTravelersDescription", "update:sectionsTravelersIds", "update:sectionsTravelersIsComplete"]);

const editId = ref(null);
const isForm = ref(false);
const isNoPax = ref(false);
const newId = ref(null);
const travelers = ref([]);

const travelersDescription = computed(() => {
  let desc = "\r\n\r\n***\r\n\r\nTRAVELERS";

  if (travelers.value.length > 0) {
    travelers.value.forEach((traveler, index) => {
      desc += `\r\nPax ${index + 1}: ${traveler.name}`;
    });
  } else {
    desc += "\r\nNone Selected";
  }

  return desc;
});

const travelersIds = computed(() => travelers.value.map(traveler => traveler.id));

watch(editId, val => {
  isForm.value = val !== null;
});

watch(newId, val => {
  if (val !== null) {
    isForm.value = false;
  }
});

watch(
  travelers,
  () => {
    emit("update:sectionsTravelersIds", travelersIds.value);
  },
  { deep: true }
);

const back = () => {
  emit("back");
};

// const add = () => {
//   isForm.value = true;
// };

// const cancel = () => {
//   isForm.value = false;
//   editId.value = null;
// };

const next = () => {
  if (props.isSelfBook && travelers.value.length === 0) {
    alert("You must select a traveler for Self Booking. Please select a traveler or change your trip to Assisted Booking (see top-right corner).");
    return;
  }
  emit("update:sectionsTravelersDescription", travelersDescription.value);
  emit("update:sectionsTravelersIds", travelersIds.value);
  emit("update:sectionsTravelersIsComplete", true);
};
</script>

<style lang="less">
#list {
  .wizard {
    .form-group {
      margin-bottom: 2rem !important;
    }
  }
}
</style>
